import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Modal, Form, Button, Alert } from "react-bootstrap";
import { toast } from "react-toastify";
import { createSav, getSavConstants } from "state/sav/actions";
import { MOTIF_LABELS, SERVICE_LABELS, labelFor } from "app/orderTool/pages/pipelineSav/savLabels";

/**
 * Déclaration SAV depuis le flux compagnon (canal COMPAGNON).
 */
const DeclareSavModal = ({ show, onClose, groupedOrderId, prestationId, declarePar, onDeclared }) => {
  const dispatch = useDispatch();
  const [constants, setConstants] = useState(null);
  const [motif, setMotif] = useState("");
  const [service, setService] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (show && !constants) {
      dispatch(getSavConstants()).then((resp) => setConstants(resp));
    }
  }, [show, constants, dispatch]);

  useEffect(() => {
    if (!show) {
      setMotif("");
      setService("");
      setDescription("");
    }
  }, [show]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!motif) {
      toast.error("Choisissez un motif");
      return;
    }
    if (!groupedOrderId && !prestationId) {
      toast.error("Prestation / commande introuvable sur cette livraison");
      return;
    }
    setLoading(true);
    const payload = {
      motif,
      service_concerne: service || "LOGISTIQUE",
      description,
      canal_declaration: "COMPAGNON",
      declare_par: declarePar || "Compagnon",
    };
    if (prestationId) {
      payload.prestation_id = parseInt(prestationId, 10);
    } else {
      payload.order_number = `M/${groupedOrderId}`;
    }
    const resp = await dispatch(createSav(payload));
    setLoading(false);
    if (resp?.error || resp?.success === false) {
      toast.error(resp?.message || "Déclaration impossible");
      return;
    }
    toast.success(resp?.message || "SAV déclaré — le pôle clientèle est alerté");
    onDeclared?.();
    onClose();
  };

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Déclarer un SAV</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Alert variant="info">
            Incident sur la prestation{" "}
            {prestationId ? (
              <strong>#{prestationId}</strong>
            ) : (
              <strong>M/{groupedOrderId}</strong>
            )}
            {groupedOrderId ? ` (devis M/${groupedOrderId})` : ""}. Le chargé de clientèle sera alerté.
          </Alert>
          <Form.Group>
            <Form.Label>Motif *</Form.Label>
            <Form.Control as="select" value={motif} onChange={(e) => setMotif(e.target.value)} required>
              <option value="">— Choisir —</option>
              {(constants?.motifs || []).map((m) => (
                <option key={m} value={m}>{labelFor(MOTIF_LABELS, m)}</option>
              ))}
            </Form.Control>
          </Form.Group>
          <Form.Group>
            <Form.Label>Service concerné</Form.Label>
            <Form.Control as="select" value={service} onChange={(e) => setService(e.target.value)}>
              <option value="">Logistique (défaut)</option>
              {(constants?.services || []).map((s) => (
                <option key={s} value={s}>{labelFor(SERVICE_LABELS, s)}</option>
              ))}
            </Form.Control>
          </Form.Group>
          <Form.Group>
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Décrivez l'incident…"
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onClose}>Annuler</Button>
          <Button variant="danger" type="submit" disabled={loading}>
            Déclarer le SAV
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default DeclareSavModal;
